/* eslint-disable react/display-name */
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { sanitizeHeaderAnchors } from 'cg/components/documents/helpers'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { Node } from 'vendor/slate'

import TabsWrapper from 'cg/components/documents/editor/slate/plugins/tabs/tabsWrapper'
import TabsHeaderWrapper from 'cg/components/documents/editor/slate/plugins/tabs/tabsHeaderWrapper'
import TabsHeaderItem from 'cg/components/documents/editor/slate/plugins/tabs/tabsHeaderItem'
import TabsContentItem from 'cg/components/documents/editor/slate/plugins/tabs/tabsContentItem'

import CodeTabsWrapper from 'cg/components/documents/editor/slate/plugins/code/codeTabsWrapper'
import CodeTabsHeaderWrapper from 'cg/components/documents/editor/slate/plugins/code/codeTabsHeaderWrapper'
import CodeTabsHeaderItem from 'cg/components/documents/editor/slate/plugins/code/codeTabsHeaderItem'
import CodeTabsContentItem from 'cg/components/documents/editor/slate/plugins/code/codeTabsContentItem'
import CodeTabsContentItemLine from 'cg/components/documents/editor/slate/plugins/code/codeTabsContentItemLine'
import CheckListItem from 'cg/components/documents/editor/slate/plugins/lists/checkListItem'
import ImageWrapper from 'cg/components/documents/editor/slate/plugins/image/imageWrapper'
import FileWrapper from 'cg/components/documents/editor/slate/plugins/file/fileWrapper'
import EmbedWrapper from 'cg/components/documents/editor/slate/plugins/embed/embedWrapper'
import MathWrapper from 'cg/components/documents/editor/slate/plugins/math/mathWrapper'
import MermaidWrapper from 'cg/components/documents/editor/slate/plugins/mermaid/mermaidWrapper'
import SwaggerWrapper from 'cg/components/documents/editor/slate/plugins/swagger/swaggerWrapper'
import GraphiqlWrapper from 'cg/components/documents/editor/slate/plugins/graphiql/graphiqlWrapper'
import TableRow from 'cg/components/documents/editor/slate/plugins/table/tableRow'
import TableHeader from 'cg/components/documents/editor/slate/plugins/table/tableHeader'
import TableCell from 'cg/components/documents/editor/slate/plugins/table/tableCell'
import Hint from 'cg/components/documents/editor/slate/plugins/hint/hint'
import AppLink from 'cg/components/documents/editor/slate/plugins/applink/appLink'
import { Mention } from 'cg/components/documents/editor/slate/plugins/mentions'
import RawMarkdownWrapper from 'cg/components/documents/editor/slate/plugins/rawMarkdown/rawMarkdownWrapper'

import ApiWrapper from 'cg/components/documents/editor/slate/plugins/api/apiWrapper'
import ApiMethodTitleWrapper from 'cg/components/documents/editor/slate/plugins/api/apiMethodTitleWrapper'
import ApiMethod from 'cg/components/documents/editor/slate/plugins/api/apiMethod'
import ApiTitle from 'cg/components/documents/editor/slate/plugins/api/apiTitle'
import ApiPath from 'cg/components/documents/editor/slate/plugins/api/apiPath'
import ApiDescription from 'cg/components/documents/editor/slate/plugins/api/apiDescription'
import ApiTabsWrapper from 'cg/components/documents/editor/slate/plugins/api/apiTabsWrapper'
import ApiTabsHeaderWrapper from 'cg/components/documents/editor/slate/plugins/api/apiTabsHeaderWrapper'
import ApiTabsHeaderItem from 'cg/components/documents/editor/slate/plugins/api/apiTabsHeaderItem'
import ApiTabsContentItem from 'cg/components/documents/editor/slate/plugins/api/apiTabsContentItem'
import refractor from 'refractor/core'
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed'
import Sidebar from 'cg/components/documents/editor/slate/sidebar'
import {
  DocumentParagraph as P,
  DocumentH1 as H1,
  DocumentH2 as H2,
  DocumentH3 as H3,
  DocumentHR as HR,
  DocumentPre as PRE,
  DocumentQuote as Quote,
  DocumentQuoteContent as QuoteContentItem,
  DocumentTable as Table,
  DocumentThead as Thead,
  DocumentTbody as Tbody
} from 'cg/components/documents/editor/slate/documentStyles'

const Element = props => {
  const { attributes, children, element, editor, themeColor, publishedDocument } = props
  const { type, parent } = element

  let text = { text: '' }
  try {
    const [[texts]] = Node.texts(element)
    text = texts
  } catch (err) {}

  switch (type) {
    case ELEMENT_TYPES.header_one:
      return (
        <>
          {publishedDocument ? (
            <ScrollIntoViewIfNeeded
              active={window.location.hash ? sanitizeHeaderAnchors(text.text) === window.location.hash.substring(1) : false}
              options={{
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
              }}
            >
              <H1
                {...attributes}
                id={sanitizeHeaderAnchors(text.text)}
                style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
              >
                {children}
              </H1>
            </ScrollIntoViewIfNeeded>
          ) : (
            <Sidebar {...props}>
              <ScrollIntoViewIfNeeded
                active={window.location.hash ? sanitizeHeaderAnchors(text.text) === window.location.hash.substring(1) : false}
                options={{
                  behavior: 'smooth',
                  block: 'start',
                  inline: 'nearest'
                }}
              >
                <H1
                  {...attributes}
                  id={sanitizeHeaderAnchors(text.text)}
                  style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
                >
                  {children}
                </H1>
              </ScrollIntoViewIfNeeded>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.header_two:
      return (
        <>
          {publishedDocument ? (
            <ScrollIntoViewIfNeeded
              active={window.location.hash ? sanitizeHeaderAnchors(text.text) === window.location.hash.substring(1) : false}
              options={{
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
              }}
            >
              <H2
                {...attributes}
                id={sanitizeHeaderAnchors(text.text)}
                style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
              >
                {children}
              </H2>
            </ScrollIntoViewIfNeeded>
          ) : (
            <Sidebar {...props}>
              <ScrollIntoViewIfNeeded
                active={window.location.hash ? sanitizeHeaderAnchors(text.text) === window.location.hash.substring(1) : false}
                options={{
                  behavior: 'smooth',
                  block: 'start',
                  inline: 'nearest'
                }}
              >
                <H2
                  {...attributes}
                  id={sanitizeHeaderAnchors(text.text)}
                  style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
                >
                  {children}
                </H2>
              </ScrollIntoViewIfNeeded>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.header_three:
      return (
        <>
          {publishedDocument ? (
            <H3
              {...attributes}
              id={sanitizeHeaderAnchors(text.text)}
              style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
            >
              {children}
            </H3>
          ) : (
            <Sidebar {...props}>
              <H3
                {...attributes}
                id={sanitizeHeaderAnchors(text.text)}
                style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}
              >
                {children}
              </H3>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.horizontal_rule:
      return (
        <>
          {publishedDocument ? (
            <div {...attributes}>
              <div contentEditable={false}>
                <HR />
                {children}
              </div>
            </div>
          ) : (
            <Sidebar {...props}>
              <div {...attributes}>
                <div contentEditable={false}>
                  <HR />
                  {children}
                </div>
              </div>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.documentlink:
    case ELEMENT_TYPES.issuelink:
    case ELEMENT_TYPES.commitlink:
    case ELEMENT_TYPES.mrlink:
      return (
        <>
          {publishedDocument ? (
            <AppLink {...props}>{children}</AppLink>
          ) : (
            <Sidebar {...props}>
              <AppLink {...props}>{children}</AppLink>
            </Sidebar>
          )}
        </>
      )

    case ELEMENT_TYPES.link:
      return (
        <>
          {element.targetBlank ? (
            <a
              {...attributes}
              style={{ color: themeColor || 'inherit' }}
              href={publishedDocument ? (element.publicUrl ? element.publicUrl : element.url) : element.url}
              target="_blank"
            >
              {children}
            </a>
          ) : (
            <a
              {...attributes}
              style={{ color: themeColor || 'inherit' }}
              href={publishedDocument ? (element.publicUrl ? element.publicUrl : element.url) : element.url}
            >
              {children}
            </a>
          )}
        </>
      )
    case ELEMENT_TYPES.emoji:
      return <span {...attributes}>{children}</span>
    case ELEMENT_TYPES.tabs:
      return (
        <>
          {publishedDocument ? (
            <TabsWrapper {...props} />
          ) : (
            <Sidebar {...props}>
              <TabsWrapper {...props} />
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.tabs_header:
      return <TabsHeaderWrapper {...props} />
    case ELEMENT_TYPES.tabs_header_item:
      return <TabsHeaderItem {...props} />
    case ELEMENT_TYPES.tabs_content_item:
      return <TabsContentItem {...props} />
    case ELEMENT_TYPES.code_tabs:
      return (
        <>
          {publishedDocument ? (
            <CodeTabsWrapper {...props} />
          ) : (
            <Sidebar {...props}>
              <CodeTabsWrapper {...props} />
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.code_tabs_header:
      return <CodeTabsHeaderWrapper {...props} />
    case ELEMENT_TYPES.code_tabs_header_item:
      return <CodeTabsHeaderItem {...props} />
    case ELEMENT_TYPES.code_tabs_content_item:
      return <CodeTabsContentItem {...props} refractor={refractor} />
    case ELEMENT_TYPES.code_tabs_content_item_line:
      return <CodeTabsContentItemLine {...props} refractor={refractor} />
    case ELEMENT_TYPES.raw_markdown:
      return (
        <>
          {publishedDocument ? (
            <RawMarkdownWrapper {...props} />
          ) : (
            <Sidebar {...props}>
              <RawMarkdownWrapper {...props} />
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.unordered_list:
      return !publishedDocument && parent && parent.type !== ELEMENT_TYPES.unordered_list ? (
        <Sidebar {...props}>
          <ul {...attributes}>{children}</ul>
        </Sidebar>
      ) : (
        <ul {...attributes}>{children}</ul>
      )
    case ELEMENT_TYPES.ordered_list:
      return !publishedDocument && parent && parent.type !== ELEMENT_TYPES.ordered_list ? (
        <Sidebar {...props}>
          <ol {...attributes}>{children}</ol>
        </Sidebar>
      ) : (
        <ol {...attributes}>{children}</ol>
      )

    case ELEMENT_TYPES.check_list:
      return !publishedDocument && parent && parent.type !== ELEMENT_TYPES.check_list ? (
        <Sidebar {...props}>
          <CheckList {...attributes}>{children}</CheckList>
        </Sidebar>
      ) : (
        <CheckList {...attributes}>{children}</CheckList>
      )
    case ELEMENT_TYPES.list_item:
      return <li {...attributes}>{children}</li>
    case ELEMENT_TYPES.check_list_item:
      return <CheckListItem {...props} />
    case ELEMENT_TYPES.quote:
      return (
        <>
          {publishedDocument ? (
            <Quote {...attributes}>{children}</Quote>
          ) : (
            <Sidebar {...props}>
              <Quote {...attributes}>{children}</Quote>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.quote_content:
      return <QuoteContentItem {...attributes}>{children}</QuoteContentItem>
    case ELEMENT_TYPES.hint:
      return (
        <>
          {publishedDocument ? (
            <Hint {...props}>{children}</Hint>
          ) : (
            <Sidebar {...props}>
              <Hint {...props}>{children}</Hint>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.hint_content:
      return <HintContent {...attributes}>{children}</HintContent>
    case ELEMENT_TYPES.image:
      return (
        <>
          {publishedDocument ? (
            <ImageWrapper {...props}>{children}</ImageWrapper>
          ) : (
            <Sidebar {...props}>
              <ImageWrapper {...props}>{children}</ImageWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.file:
      return (
        <>
          {publishedDocument ? (
            <FileWrapper {...props}>{children}</FileWrapper>
          ) : (
            <Sidebar {...props}>
              <FileWrapper {...props}>{children}</FileWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.embed:
    case ELEMENT_TYPES.video:
    case ELEMENT_TYPES.audio:
    case ELEMENT_TYPES.pdf:
    case ELEMENT_TYPES.loom:
    case ELEMENT_TYPES.figma:
    case ELEMENT_TYPES.gist:
    case ELEMENT_TYPES.typeform:
    case ELEMENT_TYPES.google_drive:
      return (
        <>
          {publishedDocument ? (
            <EmbedWrapper {...props}>{children}</EmbedWrapper>
          ) : (
            <Sidebar {...props}>
              <EmbedWrapper {...props}>{children}</EmbedWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.math:
      return (
        <>
          {publishedDocument ? (
            <MathWrapper {...props}>{children}</MathWrapper>
          ) : (
            <Sidebar {...props}>
              <MathWrapper {...props}>{children}</MathWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.mermaid:
      return (
        <>
          {publishedDocument ? (
            <MermaidWrapper {...props}>{children}</MermaidWrapper>
          ) : (
            <Sidebar {...props}>
              <MermaidWrapper {...props}>{children}</MermaidWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.swagger:
      return (
        <>
          {publishedDocument ? (
            <SwaggerWrapper {...props}>{children}</SwaggerWrapper>
          ) : (
            <Sidebar {...props}>
              <SwaggerWrapper {...props}>{children}</SwaggerWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.graphiql:
      return (
        <>
          {publishedDocument ? (
            <GraphiqlWrapper {...props}>{children}</GraphiqlWrapper>
          ) : (
            <Sidebar {...props}>
              <GraphiqlWrapper {...props}>{children}</GraphiqlWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.table:
      return (
        <>
          {publishedDocument ? (
            <Table {...attributes}>{children}</Table>
          ) : (
            <Sidebar {...props}>
              <Table {...attributes}>{children}</Table>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.table_thead:
      return <Thead {...attributes}>{children}</Thead>
    case ELEMENT_TYPES.table_tbody:
      return <Tbody {...attributes}>{children}</Tbody>
    case ELEMENT_TYPES.table_tr:
      return <TableRow {...props}>{children}</TableRow>
    case ELEMENT_TYPES.table_th:
      return <TableHeader {...props}>{children}</TableHeader>
    case ELEMENT_TYPES.table_td:
      return <TableCell {...props}>{children}</TableCell>
    case ELEMENT_TYPES.api:
      return (
        <>
          {publishedDocument ? (
            <ApiWrapper {...props}>{children}</ApiWrapper>
          ) : (
            <Sidebar {...props}>
              <ApiWrapper {...props}>{children}</ApiWrapper>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.api_method_and_title:
      return <ApiMethodTitleWrapper {...props}>{children}</ApiMethodTitleWrapper>
    case ELEMENT_TYPES.api_method:
      return <ApiMethod {...props}>{children}</ApiMethod>
    case ELEMENT_TYPES.api_title:
      return <ApiTitle {...props}>{children}</ApiTitle>
    case ELEMENT_TYPES.api_path:
      return <ApiPath {...props}>{children}</ApiPath>
    case ELEMENT_TYPES.api_description:
      return <ApiDescription {...props}>{children}</ApiDescription>
    case ELEMENT_TYPES.api_tabs:
      return <ApiTabsWrapper {...props} />
    case ELEMENT_TYPES.api_tabs_header:
      return <ApiTabsHeaderWrapper {...props} />
    case ELEMENT_TYPES.api_tabs_header_item:
      return <ApiTabsHeaderItem {...props} />
    case ELEMENT_TYPES.api_tabs_content_item:
      return <ApiTabsContentItem {...props} />
    case ELEMENT_TYPES.api_request:
      return (
        <>
          {publishedDocument ? (
            <ApiItem {...attributes}>{children}</ApiItem>
          ) : (
            <Sidebar {...props}>
              <ApiItem {...attributes}>{children}</ApiItem>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.api_response:
      return (
        <>
          {publishedDocument ? (
            <ApiItem {...attributes}>{children}</ApiItem>
          ) : (
            <Sidebar {...props}>
              <ApiItem {...attributes}>{children}</ApiItem>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.mention:
      if (!publishedDocument) return <Mention {...props} />
      return <span />
    case ELEMENT_TYPES.code_no_tabs:
      return (
        <>
          {publishedDocument ? (
            <PRE {...props}>{children}</PRE>
          ) : (
            <Sidebar {...props}>
              <PRE {...props}>{children}</PRE>
            </Sidebar>
          )}
        </>
      )
    case ELEMENT_TYPES.default:
    default:
      return (
        <>
          {publishedDocument ? (
            <P {...attributes} style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}>
              {children}
            </P>
          ) : (
            <Sidebar {...props}>
              <P {...attributes} style={{ textAlign: `${element.alignment || ELEMENT_TYPES.alignInitial}` }}>
                {children}
              </P>
            </Sidebar>
          )}
        </>
      )
  }
}

export default Element

const CheckList = styled.ul`
  list-style-type: none;
  padding-inline-start: 20px;
  ul {
    padding-inline-start: 40px;
  }
`

const HintContent = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  padding: 0px 20px 0px 20px;
`

const ApiItem = styled.div`
  margin-bottom: 15px;
`
